module.exports = __webpack_public_path__ + "img/chevron-up.134bd143.svg";